import script from "./AboutView.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutView.vue?vue&type=script&setup=true&lang=js"

import "./AboutView.vue?vue&type=style&index=0&id=7997168e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7997168e"]])

export default __exports__